import React, { lazy } from "react";

const ListagemAplicativos = lazy(() => import("../Pages/ListagemAplicativos"));
const Cadastro = lazy(() => import("../Pages/Cadastro"));
const TesteAPPMarimex = lazy(() => import("../Pages/TesteAPPMarimex"));

//Reefer
const ControleReefer = lazy(() =>
    import("../Pages/ControleReefer/ControlerReefer")
);
const Habilitacao = lazy(() => import("../Pages/Habilitacao"));
const PendenteMonitoramentoReefer = lazy(() =>
    import("../Pages/PendenteMonitoramentoReefer")
);
const RegistrarLeitura = lazy(() =>
    import("../Pages/ControleReefer/components/LeituraTemperatura")
);
const RegistrarFoto = lazy(() =>
    import("../Pages/ControleReefer/components/RegistrarFoto")
);

//CarregaDescarregaVolumeMercadoria
const CarregaDescarregaVolumeMercadoria = lazy(() =>
    import("../Pages/CarregaDescarregaVolumeMercadoria/components/ListaOperacoes")
);
const CarregaDescarregaVolumeMercadoriaDetalheOperacao = lazy(() =>
    import("../Pages/CarregaDescarregaVolumeMercadoria/components/DetalheOperacao")
);
const CarregaDescarregaVolumeMercadoriaAutorizarEntrada = lazy(() =>
    import("../Pages/CarregaDescarregaVolumeMercadoria/components/AutorizarEntrada")
);
const CarregaDescarregaVolumeMercadoriaCarregamentoMenu = lazy(() =>
    import("../Pages/CarregaDescarregaVolumeMercadoria/components/CarregamentoCargaSoltaMenu")
);
const CarregaDescarregaVolumeMercadoriaRecursosCarregamento = lazy(() =>
    import("../Pages/CarregaDescarregaVolumeMercadoria/components/RecursosCarregamento")
);
const CarregaDescarregaVolumeMercadoriaCarregamentoDetalhe = lazy(() =>
    import("../Pages/CarregaDescarregaVolumeMercadoria/components/CarregamentoCargaSoltaDetalhe")
);
const CarregaDescarregaVolumeMercadoriaCarregamentoCarregar = lazy(() =>
    import("../Pages/CarregaDescarregaVolumeMercadoria/components/CarregamentoCargaSoltaCarregar")
);
const CarregaDescarregaVolumeMercadoriaAcrescimo = lazy(() =>
    import("../Pages/CarregaDescarregaVolumeMercadoria/components/Acrescimo")
)
const CarregaDescarregaVolumeMercadoriaDescargaMenu = lazy(() =>
    import("../Pages/CarregaDescarregaVolumeMercadoria/components/DescargaCargaSoltaMenu")
);
const CarregaDescarregaVolumeMercadoriaRecursosDescarga = lazy(() =>
    import("../Pages/CarregaDescarregaVolumeMercadoria/components/RecursosDescarga")
);
const CarregaDescarregaVolumeMercadoriaDescargaDetalhesVolume = lazy(() =>
    import("../Pages/CarregaDescarregaVolumeMercadoria/components/DetalhesVolume")
);
const CarregaDescarregaVolumeMercadoriaDescargaDescarregar = lazy(() =>
    import("../Pages/CarregaDescarregaVolumeMercadoria/components/DescargaCargaSoltaDescarregar")
);
const CarregaDescarregaVolumeMercadoriaDescargaReconhecimento = lazy(() =>
    import("../Pages/CarregaDescarregaVolumeMercadoria/components/DescargaCargaSoltaReconhecimento")
);
const CarregaDescarregaVolumeMercadoriaDescargaReconhecer = lazy(() =>
    import("../Pages/CarregaDescarregaVolumeMercadoria/components/DescargaCargaSoltaReconhecer")
);
const AvariaCargaSolta = lazy(() =>
    import("../Pages/CarregaDescarregaVolumeMercadoria/components/AvariaCargaSolta")
);
const CarregaDescarregaVolumeMercadoriaLonamento = lazy(() =>
    import("../Pages/CarregaDescarregaVolumeMercadoria/components/LonamentoCargaSolta")
);
const CarregaDescarregaVolumeMercadoriaInterromperOperacao = lazy(() =>
    import("../Pages/CarregaDescarregaVolumeMercadoria/components/InterromperOperacao")
);
const CarregaDescarregaVolumeMercadoriaCheckListPeacao = lazy(() =>
    import("../Pages/CarregaDescarregaVolumeMercadoria/components/CheckListPeacao")
);
const CarregaDescarregaVolumeMercadoriaCarregamentoCargaSoltaDesovando = lazy(() =>
    import("../Pages/CarregaDescarregaVolumeMercadoria/components/CarregamentoCargaSoltaDesovando")
)
const CarregaDescarregaVolumeMercadoriaCarregamentoCargaSoltaDesovandoAcrescimo = lazy(() =>
    import("../Pages/CarregaDescarregaVolumeMercadoria/components/AcrescimoDesova")
)
const CarregaDescarregaVolumeMercadoriaCarregamentoCargaSoltaDesovar = lazy(() =>
    import("../Pages/CarregaDescarregaVolumeMercadoria/components/CarregamentoCargaSoltaDesovar")
)
const CarregaDescarregaVolumeMercadoriaCarregamentoCargaSoltaDesovarAvaria = lazy(() =>
    import("../Pages/CarregaDescarregaVolumeMercadoria/components/CarregamentoCargaSoltaDesovarAvaria")
)
const CarregaDescarregaVolumeMercadoriaCarregamentoCargaSoltaFinalizarDesova = lazy(() =>
    import("../Pages/CarregaDescarregaVolumeMercadoria/components/CarregamentoCargaSoltaFinalizarDesova")
)
const CarregaDescarregaVolumeMercadoriaCarregamentoCargaSoltaFinalizarDesovaAvaria = lazy(() =>
    import("../Pages/CarregaDescarregaVolumeMercadoria/components/CarregamentoCargaSoltaFinalizarDesovaAvaria")
)
const CarregaDescarregaVolumeMercadoriaCarregamentoCargaSoltaFinalizarDesovaPeacao = lazy(() =>
    import("../Pages/CarregaDescarregaVolumeMercadoria/components/CarregamentoCargaSoltaFinalizarDesovaPeacao")
)

//CarregaDescarregaContainer
const CarregaDescarregaContainer = lazy(() =>
    import("../Pages/CarregaDescarregaContainer/components/ListaGate")
);
const CarregaDescarregaContainerDetalheGate = lazy(() =>
    import("../Pages/CarregaDescarregaContainer/components/DetalheGate")
);
const CarregaDescarregaDetalheDescarregaGate = lazy(() =>
    import(
        "../Pages/CarregaDescarregaContainer/components/DetalheDescarregaGate"
    )
);
const CarregaDescarregaDescarregaGate = lazy(() =>
    import("../Pages/CarregaDescarregaContainer/components/DescarregaGate")
);
const CarregaDescarregaDetalheCarregaGate = lazy(() =>
    import("../Pages/CarregaDescarregaContainer/components/DetalheCarregaGate")
);
const CarregaDescarregaCarregaGate = lazy(() =>
    import("../Pages/CarregaDescarregaContainer/components/CarregaGate")
);
const CarregaDescarregaAutorizarEntrada = lazy(() =>
    import("../Pages/CarregaDescarregaContainer/components/AutorizarEntrada")
);
const CarregaDescarregaInterromperOperacao = lazy(() =>
    import("../Pages/CarregaDescarregaContainer/components/InterromperOperacao")
);
const CarregamentoPosDescarga = lazy(() =>
    import("../Pages/CarregaDescarregaContainer/components/CarregamentoPosDescarga")
);

//Desova
const ColetorDesova = lazy(() =>
    import("../Pages/Desova/index")
);
const IniciarDesova = lazy(() =>
    import("../Pages/Desova/components/IniciarDesova")
);
const InterromperDesova = lazy(() =>
    import("../Pages/Desova/components/InterromperDesova")
);
const Desovando = lazy(() =>
    import("../Pages/Desova/components/Desovando")
);
const Desovar = lazy(() =>
    import("../Pages/Desova/components/Desovar")
);
const AvariasVolumeDesova = lazy(() =>
    import("../Pages/Desova/components/AvariasVolume")
);
const AvariasContainerDesova = lazy(() =>
    import("../Pages/Desova/components/AvariasContainer")
);
const DetalhesVolumeDesova = lazy(() =>
    import("../Pages/Desova/components/DetalhesVolume")
);
const InformacoesSiscomexDesova = lazy(() =>
    import("../Pages/Desova/components/InformacoesSiscomex")
);
const FinalizarDesova = lazy(() =>
    import("../Pages/Desova/components/FinalizarDesova")
);
const AcrescimoDesova = lazy(() =>
    import("../Pages/Desova/components/Acrescimo")
)
const PeacaoDesova = lazy(() =>
    import("../Pages/Desova/components/CheckListPeacao")
)


//Remoção
const Remocao = lazy(() => import("../Pages/Remocao"));
const EscolhePickup = lazy(() => import("../Pages/Remocao/EscolhePickup"));
const PosicionarContainer = lazy(() =>
    import("../Pages/Remocao/PosicionarContainer")
);

//Vistoria
const Vistoria = lazy(() =>
    import("../Pages/CarregaDescarregaContainer/components/Vistoria")
);
const Avaria = lazy(() =>
    import("../Pages/CarregaDescarregaContainer/components/Avaria")
);
const AvariaOEA = lazy(() =>
    import("../Pages/CarregaDescarregaContainer/components/AvariaOEA")
);
const Lacres = lazy(() =>
    import("../Pages/CarregaDescarregaContainer/components/Lacres")
);

//Consultas Gerais
const ConsultasGerais = lazy(() =>
    import("../Pages/ConsultasGerais/ConsultasGerais")
);

//Controle AG
const ArmazemGeral = lazy(() => import("../Pages/ArmazemGeral"));
// Controle AG / Remontagem AG
const RemontagemAG = lazy(() =>
    import("../Pages/ArmazemGeral/components/Remontagem")
);

// Entreposto
const Entreposto = lazy(() => import("../Pages/Entreposto"));
// Entreposto /  Remontagem Entreposto
const RemontagemEntreposto = lazy(() =>
    import("../Pages/Entreposto/components/Remontagem/index")
);
// Entreposto / Reconhecimento de Itens
const ReconhecimentoDeItens = lazy(() =>
    import("../Pages/Entreposto/components/ReconhecimentoDeItens")
);
// Entreposto / Enderecamento
const EnderecamentoAG = lazy(() =>
    import("../Pages/Entreposto/components/Enderecamento")
);
// Entreposto / BaixaDA
const BaixaDA = lazy(() => import("../Pages/Entreposto/components/BaixaDA"));

// Inventário
const Inventario = lazy(() => import("../Pages/Inventario"));
// Inventário / Adicionar Item
const AdicionarItemInventario = lazy(() =>
    import("../Pages/Inventario/components/Adicionar")
);
// Inventário / Inconsistências
const InconsistenciasInventario = lazy(() =>
    import("../Pages/Inventario/components/Inconsistencia")
);
// Sol Serv Picking
const SolServPicking = lazy(() => import("../Pages/SolServPicking"));

// SolServ
const SolServ = lazy(() => import("../Pages/SolServ"));

// SolServItensEstufagem
const SolServItensEstufagem = lazy(() => import("../Pages/SolServ/components/SolicitarServicoItensEstufagem"));

const SolServIniciarDesova = lazy(() => import("../Pages/SolServ/components/IniciarDesova"));

const SolServDesovando = lazy(() => import("../Pages/SolServ/components/Desovando"));

const SolServAcrescimo = lazy(() => import("../Pages/SolServ/components/Acrescimo"));

const SolServDesovar = lazy(() => import("../Pages/SolServ/components/Desovar"));

const SolServAvariasVolume = lazy(() => import("../Pages/SolServ/components/AvariasVolume"));

const SolServDetalhesVolume = lazy(() => import("../Pages/SolServ/components/DetalhesVolume"));

const SolServFinalizarDesova = lazy(() => import("../Pages/SolServ/components/FinalizarDesova"));

const SolServAvariasContainer = lazy(() => import("../Pages/SolServ/components/AvariasContainer"));

// VolumeEstufagem
const VolumeEstufagem = lazy(() => import("../Pages/SolServ/components/VolumeEstufagem"));

// InterromperEstufagem
const InterromperEstufagem = lazy(() => import("../Pages/SolServ/components/InterromperEstufagem"));

// FinalizarSolServEstufagem
const FinalizarSolServEstufagem = lazy(() => import("../Pages/SolServ/components/FinalizarSolServEstufagem"));

// FinalizarSolServEstufagemPeacao
const FinalizarSolServEstufagemPeacao = lazy(() => import("../Pages/SolServ/components/FinalizarSolServEstufagemPeacao"));

// Descarrega Carregamento
const DescarregaCarregamento = lazy(() =>
    import("../Pages/DescarregaCarregamento")
);
// Desc. Carregamento / Carregamento Carga Solta
const CarregamentoCargaSolta = lazy(() =>
    import("../Pages/DescarregaCarregamento/features/CarregamentoCargaSolta")
);
// Desc. Carregamento / DDC
const DDC = lazy(() => import("../Pages/DescarregaCarregamento/features/DDC"));
// Desc. Carregamento / Carregamento AG
const CarregamentoAG = lazy(() =>
    import("../Pages/DescarregaCarregamento/features/CarregamentoAG")
);
// Desc. Carregamento / DescargaEXP
const DescargaEXP = lazy(() =>
    import("../Pages/DescarregaCarregamento/features/DescargaExp")
);

const SolServDesova = lazy(() =>
    import("../Pages/SolServDesova/index")
);
const SolServDesovaDetalhesContainer = lazy(() =>
    import("../Pages/SolServDesova/components/DetalhesContainer")
)
const SolServDesovaIniciarDesova = lazy(() =>
    import("../Pages/SolServDesova/components/IniciarDesova")
)
const SolServDesovaInterromperDesova = lazy(() =>
    import("../Pages/SolServDesova/components/InterromperDesova")
)
const SolServDesovaDesovarVolume = lazy(() =>
    import("../Pages/SolServDesova/components/DesovarVolume")
)
const SolServDesovaAvariasVolume = lazy(() =>
    import("../Pages/SolServDesova/components/AvariasVolume")
)
const SolServDesovaReconhecimentoVolume = lazy(() =>
    import("../Pages/SolServDesova/components/ReconhecimentoVolume")
)
const SolServDesovaReconhecerVolume = lazy(() =>
    import("../Pages/SolServDesova/components/ReconhecerVolume")
)
const SolServDesovaFinalizarDesova = lazy(() =>
    import("../Pages/SolServDesova/components/FinalizarDesova")
)
const AvariasContainer = lazy(() =>
    import("../Pages/SolServDesova/components/AvariasContainer")
)

//Remocao Volume
const RemocaoVolume = lazy(() =>
    import("../Pages/RemocaoVolume/index")
)

//Edicao Volumes
const EdicaoVolumes = lazy(() =>
    import("../Pages/EdicaoVolumes/index")
)

//Operacoes Container
const OperacaoContainerCodigoDeBarras = lazy(() =>
    import("../Pages/OperacaoContainer/index"));
const OperacaoContainerPrincipal = lazy(() =>
    import("../Pages/OperacaoContainer/components/Principal"));
const OperacaoContainerFiscal = lazy(() =>
    import("../Pages/OperacaoContainer/components/Fiscal"));

// Remontagem Volume
const RemontagemVolume = lazy(() =>
    import("../Pages/RemontagemVolume/index")
);

const RemontarVolume = lazy(() =>
    import("../Pages/RemontagemVolume/components/RemontarVolume")
);


const AvariaMovimentacaoVolume = lazy(() =>
    import("../Pages/AvariaMovimentacaoVolume/components/AvariasVolume")
);

//ImagensApp
const Confere = lazy(() =>
    import("../Pages/ImagensApp/Confere/index"));
const ConfirmaImagem = lazy(() =>
    import("../Pages/ImagensApp/ConfirmaImagem/index"));
const Consulta = lazy(() =>
    import("../Pages/ImagensApp/Consulta/index"));
const ImagensEmGeral = lazy(() =>
    import("../Pages/ImagensApp/ImagensEmGeral/index"));
const TipoImagem = lazy(() =>
    import("../Pages/ImagensApp/TipoImagem/index"));
const ImagensApp = lazy(() =>
    import("../Pages/ImagensApp/index"));


//VistoriaOEA
const VistoriaOEA = lazy(() => import("../Pages/Vistoria OEA/index"));


//PortariaApp
const PortariaApp = lazy(() => import("../Pages/PortariaApp/index"));


const RoutesMenu = [
    {
        path: "/Cadastro",
        component: Cadastro,
        title: "Cadastro"
    },
    {
        path: "/remocao",
        component: Remocao,
        title: "Remoção"
    },
    {
        path: "/remocao/escolhepickup",
        component: EscolhePickup,
        title: "Pickup"
    },
    {
        path: "/remocao/posicionarcontainer",
        component: PosicionarContainer,
        title: "Posicionar"
    },
    {
        path: "/TesteAPPMarimex",
        component: TesteAPPMarimex,
        title: "Teste APP Marimex"
    },
    {
        path: "/Reefer/ConsultaContainer",
        component: ControleReefer,
        title: "Controle Reefer"
    },
    {
        path: "/Reefer/PendenteMonitoramento",
        sidebarName: "Reefer Pendente Monitoramento",
        component: PendenteMonitoramentoReefer,
        title: "Leituras Pendentes"
    },
    {
        path: "/Reefer/RegistrarLeitura",
        sidebarName: "Reefer Registrar Leitura",
        component: RegistrarLeitura,
        title: "Registrar Leitura"
    },
    {
        path: "/Reefer/RegistrarLeitura/RegistrarFoto",
        sidebarName: "Reefer Registrar Foto",
        component: RegistrarFoto,
        title: "Registrar Foto"
    },
    {
        path: "/HabilitaTurno",
        sidebarName: "Habilita Turno",
        component: Habilitacao,
        title: "Habilita Turno"
    },
    {
        path: "/CarregaDescarregaVolumeMercadoria/ListaOperacoes",
        component: CarregaDescarregaVolumeMercadoria,
        title: "Carrega Descarrega Volume Mercadoria"
    },
    {
        path: "/CarregaDescarregaVolumeMercadoria/DetalheOperacao",
        component: CarregaDescarregaVolumeMercadoriaDetalheOperacao,
        title: "Carrega Descarrega Volume Mercadoria - Detalhe"
    },
    {
        path: "/CarregaDescarregaVolumeMercadoria/AutorizarEntrada",
        component: CarregaDescarregaVolumeMercadoriaAutorizarEntrada,
        title: "Carrega Descarrega Volume Mercadoria - Autorizar Entrada"
    },
    {
        path: "/CarregaDescarregaVolumeMercadoria/Carregamento",
        component: CarregaDescarregaVolumeMercadoriaCarregamentoMenu,
        title: "Carrega Volume Mercadoria"
    },
    {
        path: "/CarregaDescarregaVolumeMercadoria/RecursosCarregamento",
        component: CarregaDescarregaVolumeMercadoriaRecursosCarregamento,
        title: "Carrega Volume Mercadoria - Recursos"
    },
    {
        path: "/CarregaDescarregaVolumeMercadoria/Carregamento/Detalhe",
        component: CarregaDescarregaVolumeMercadoriaCarregamentoDetalhe,
        title: "Carrega Volume Mercadoria - Detalhe"
    },
    {
        path: "/CarregaDescarregaVolumeMercadoria/Carregamento/Carregar",
        component: CarregaDescarregaVolumeMercadoriaCarregamentoCarregar,
        title: "Carrega Volume Mercadoria - Carregar"
    },
    {
        path: "/CarregaDescarregaVolumeMercadoria/Descarga/Acrescimo",
        component: CarregaDescarregaVolumeMercadoriaAcrescimo,
        title: "Descarrega Volume Mercadoria - Acrescimo"
    },
    {
        path: "/CarregaDescarregaVolumeMercadoria/Descarga",
        component: CarregaDescarregaVolumeMercadoriaDescargaMenu,
        title: "Descarrega Volume Mercadoria"
    },
    {
        path: "/CarregaDescarregaVolumeMercadoria/RecursosDescarga",
        component: CarregaDescarregaVolumeMercadoriaRecursosDescarga,
        title: "Descarrega Volume Mercadoria - Recursos"
    },
    {
        path: "/CarregaDescarregaVolumeMercadoria/Descarga/DetalhesVolume",
        component: CarregaDescarregaVolumeMercadoriaDescargaDetalhesVolume,
        title: "Descarrega Volume Mercadoria - Detalhes Volume"
    },
    {
        path: "/CarregaDescarregaVolumeMercadoria/Descarga/Descarregar",
        component: CarregaDescarregaVolumeMercadoriaDescargaDescarregar,
        title: "Descarrega Volume Mercadoria - Descarregar"
    },
    {
        path: "/CarregaDescarregaVolumeMercadoria/Descarga/Reconhecimento",
        component: CarregaDescarregaVolumeMercadoriaDescargaReconhecimento,
        title: "Descarrega Volume Mercadoria - Reconhecimento"
    },
    {
        path: "/CarregaDescarregaVolumeMercadoria/Descarga/Reconhecer",
        component: CarregaDescarregaVolumeMercadoriaDescargaReconhecer,
        title: "Descarrega Volume Mercadoria - Reconhecer"
    },
    {
        path: "/CarregaDescarregaVolumeMercadoria/Descarga/Avaria",
        component: AvariaCargaSolta,
        title: "Descarrega Volume Mercadoria - Avaria"
    },
    {
        path: "/CarregaDescarregaVolumeMercadoria/Lonamento",
        component: CarregaDescarregaVolumeMercadoriaLonamento,
        title: "Carrega Volume Mercadoria - Lonamento"
    },
    {
        path: "/CarregaDescarregaVolumeMercadoria/InterromperOperacao",
        component: CarregaDescarregaVolumeMercadoriaInterromperOperacao,
        title: "Carrega Descarrega Volume Mercadoria - Interromper Operação"
    },
    {
        path: "/CarregaDescarregaVolumeMercadoria/CheckListPeacao",
        component: CarregaDescarregaVolumeMercadoriaCheckListPeacao,
        title: "Carrega Volume Mercadoria - Checklist Peação"
    },
    {
        path: "/CarregaDescarregaVolumeMercadoria/Desovando",
        component: CarregaDescarregaVolumeMercadoriaCarregamentoCargaSoltaDesovando,
        title: "Carrega Volume Mercadoria - DDC"
    },
    {
        path: "/CarregaDescarregaVolumeMercadoria/Desovando/Acrescimo",
        component: CarregaDescarregaVolumeMercadoriaCarregamentoCargaSoltaDesovandoAcrescimo,
        title: "Carrega Volume Mercadoria - DDC - Acrescimo"

    },
    {
        path: "/CarregaDescarregaVolumeMercadoria/Desovar",
        component: CarregaDescarregaVolumeMercadoriaCarregamentoCargaSoltaDesovar,
        title: "Carrega Volume Mercadoria - DDC - Desovar"
    },
    {
        path: "/CarregaDescarregaVolumeMercadoria/Desovar/AvariasVolume",
        component: CarregaDescarregaVolumeMercadoriaCarregamentoCargaSoltaDesovarAvaria,
        title: "Carrega Volume Mercadoria - DDC - Avarias Volume"
    },
    {
        path: "/CarregaDescarregaVolumeMercadoria/FinalizarDesova",
        component: CarregaDescarregaVolumeMercadoriaCarregamentoCargaSoltaFinalizarDesova,
        title: "Carrega Volume Mercadoria - DDC - Finalizar Desova"
    },
    {
        path: "/CarregaDescarregaVolumeMercadoria/FinalizarDesova/AvariasContainer",
        component: CarregaDescarregaVolumeMercadoriaCarregamentoCargaSoltaFinalizarDesovaAvaria,
        title: "Carrega Volume Mercadoria - DDC - Finalizar Desova - Avaria"
    },
    {
        path: "/CarregaDescarregaVolumeMercadoria/FinalizarDesova/Peacao",
        component: CarregaDescarregaVolumeMercadoriaCarregamentoCargaSoltaFinalizarDesovaPeacao,
        title: "Carrega Volume Mercadoria - DDC - Finalizar Peação Desova"
    },
    {
        path: "/CarregaDescarregaContainer/ListaGate",
        component: CarregaDescarregaContainer,
        title: "Operações de Pátio"
    },
    {
        path: "/CarregaDescarregaContainer/DetalheGate",
        component: CarregaDescarregaContainerDetalheGate,
        title: "Detalhes do Gate"
    },
    {
        path: "/CarregaDescarregaContainer/Vistoria",
        component: Vistoria,
        title: "Vistoria"
    },
    {
        path: "/CarregaDescarregaContainer/Avaria",
        component: Avaria,
        title: "Avarias"
    },
    {
        path: "/CarregaDescarregaContainer/AvariaOEA",
        component: AvariaOEA,
        title: "Avarias OEA"
    },
    {
        path: "/CarregaDescarregaContainer/Lacres",
        component: Lacres,
        title: "Lacres"
    },
    {
        path: "/CarregaDescarregaContainer/DetalheDescarregaGate",
        component: CarregaDescarregaDetalheDescarregaGate,
        title: "Descarga de Veículo"
    },
    {
        path: "/CarregaDescarregaContainer/DescarregaGate",
        component: CarregaDescarregaDescarregaGate,
        title: "Descarrega Gate"
    },
    {
        path: "/CarregaDescarregaContainer/DetalheCarregaGate",
        component: CarregaDescarregaDetalheCarregaGate,
        title: "Carregamento de Veículo"
    },
    {
        path: "/CarregaDescarregaContainer/CarregaGate",
        component: CarregaDescarregaCarregaGate,
        title: "Carrega Gate"
    },
    {
        path: "/CarregaDescarregaContainer/AutorizarEntrada",
        component: CarregaDescarregaAutorizarEntrada,
        title: "Autorizar Entrada"
    },
    {
        path: "/CarregaDescarregaContainer/InterromperOperacao",
        component: CarregaDescarregaInterromperOperacao,
        title: "Interrupção"
    },
    {
        path: "/CarregaDescarregaContainer/CarregamentoPosDescarga",
        component: CarregamentoPosDescarga,
        title: "Carregamento Pós Descarga"
    },
    {
        path: "/ColetorDesova",
        component: ColetorDesova,
        title: "Coletor Desova - Containers"
    },
    {
        path: "/ColetorDesova/IniciarDesova",
        component: IniciarDesova,
        title: "Coletor Desova - Iniciar Desova"
    },
    {
        path: "/ColetorDesova/InterromperDesova",
        component: InterromperDesova,
        title: "Coletor Desova - Interromper Desova"
    },
    {
        path: "/ColetorDesova/Desovando",
        component: Desovando,
        title: "Coletor Desova - Desovando"
    },
    {
        path: "/ColetorDesova/Desovar",
        component: Desovar,
        title: "Coletor Desova - Desovar"
    },
    {
        path: "/ColetorDesova/AvariasVolume",
        component: AvariasVolumeDesova,
        title: "Coletor Desova - Avarias Volume"
    },
    {
        path: "/ColetorDesova/AvariasContainer",
        component: AvariasContainerDesova,
        title: "Coletor Desova - Avarias Container"
    },
    {
        path: "/ColetorDesova/DetalhesVolume",
        component: DetalhesVolumeDesova,
        title: "Coletor Desova - Detalhes Volume"
    },
    {
        path: "/ColetorDesova/InformacoesSiscomex",
        component: InformacoesSiscomexDesova,
        title: "Coletor Desova - Informações Siscomex"
    },
    {
        path: "/ColetorDesova/FinalizarDesova",
        component: FinalizarDesova,
        title: "Coletor Desova - Finalizar Desova"
    },
    {
        path: "/ColetorDesova/Acrescimo",
        component: AcrescimoDesova,
        title: "Coletor Desova - Acréscimo"
    },
    {
        path: "/ColetorDesova/Peacao",
        component: PeacaoDesova,
        title: "Coletor Desova - Peação"
    },
    {
        path: "/ConsultasGerais",
        component: ConsultasGerais,
        title: "Consultas Gerais"
    },
    {
        path: "/ArmazemGeral",
        component: ArmazemGeral,
        title: "Armazém Geral"
    },
    {
        path: "/ArmazemGeral/Remontagem",
        component: RemontagemAG,
        title: "Remontagem Armazém Geral"
    },
    {
        path: "/Entreposto",
        component: Entreposto,
        title: "Entreposto"
    },
    {
        path: "/Entreposto/Remontagem",
        component: RemontagemEntreposto,
        title: "Remontagem"
    },
    {
        path: "/Entreposto/ReconhecimentoDeItens",
        component: ReconhecimentoDeItens,
        title: "Reconhecimento de Itens"
    },
    {
        path: "/Entreposto/Enderecamento",
        component: EnderecamentoAG,
        title: "Posicionamento de Vol."
    },
    {
        path: "/Entreposto/BaixaDA",
        component: BaixaDA,
        title: "Baixa de Documento"
    },
    {
        path: "/Inventario",
        component: Inventario,
        title: "Inventário"
    },
    {
        path: "/Inventario/Adicionar",
        component: AdicionarItemInventario,
        title: "Adicionar Inventário"
    },
    {
        path: "/Inventario/Inconsistencia",
        component: InconsistenciasInventario,
        title: "Inconsistência"
    },
    {
        path: "/SolServPicking",
        component: SolServPicking,
        title: "Sol Serv Picking"
    },
    {
        path: "/SolServ",
        component: SolServ,
        title: "Sol Serv"
    },
    {
        path: "/SolServ/SolServIniciarDesova",
        component: SolServIniciarDesova,
        title: "Sol Serv - Iniciar Desova"
    },
    {
        path: "/SolServ/SolServDesovando",
        component: SolServDesovando,
        title: "Sol Serv - Desovando"
    },
    {
        path: "/SolServ/SolServAcrescimo",
        component: SolServAcrescimo,
        title: "Sol Serv - Desovando - Acrescimo"
    },
    {
        path: "/SolServ/SolServDesovar",
        component: SolServDesovar,
        title: "Sol Serv - Desova"
    },
    {
        path: "/SolServ/SolServDetalhesVolume",
        component: SolServDetalhesVolume,
        title: "Sol Serv - Desova - Detalhes Volume"
    },
    {
        path: "/SolServ/SolServFinalizarDesova",
        component: SolServFinalizarDesova,
        title: "Sol Serv - Desova - Finalizar Desova"
    },
    {
        path: "/SolServ/SolServAvariaVolume",
        component: SolServAvariasVolume,
        title: "Sol Serv - Desova - Avarias Volume"
    },
    {
        path: "/SolServ/SolServAvariasContainer",
        component: SolServAvariasContainer,
        title: "Sol Serv - Desova - Avarias Container"
    },
    {
        path: "/SolServ/SolServItensEstufagem",
        component: SolServItensEstufagem,
        title: "Sol Serv - Itens Estufagem"
    },
    {
        path: "/SolServ/VolumeEstufagem",
        component: VolumeEstufagem,
        title: "Sol Serv - Volume"
    },
    {
        path: "/SolServ/InterromperEstufagem",
        component: InterromperEstufagem,
        title: "Sol Serv - Interromper Estufagem"
    },
    {
        path: "/SolServ/FinalizarSolServEstufagem",
        component: FinalizarSolServEstufagem,
        title: "Sol Serv - Finalizar Estufagem"
    },
    {
        path: "/SolServ/FinalizarSolServEstufagemPeacao",
        component: FinalizarSolServEstufagemPeacao,
        title: "Sol Serv - Recursos"
    },
    {
        path: "/DescarregaCarregamento",
        component: DescarregaCarregamento,
        title: "Coletor Desc. Carregamento"
    },
    {
        path: "/DescarregaCarregamento/CarregamentoCargaSolta/:id",
        component: CarregamentoCargaSolta,
        title: "Coletor Desc. Carregamento"
    },
    {
        path: "/DescarregaCarregamento/DDC/:id",
        component: DDC,
        title: "Coletor Desc. Carregamento"
    },
    {
        path: "/DescarregaCarregamento/CarregamentoAG/:id",
        component: CarregamentoAG,
        title: "Coletor Desc. Carregamento"
    },
    {
        path: "/DescarregaCarregamento/DescargaEXP/:id",
        component: DescargaEXP,
        title: "Coletor Desc. Carregamento"
    },


    {
        path: "/SolServDesova",
        component: SolServDesova,
        title: "Sol Serv Desova"
    },
    {
        path: "/SolServDesova/DetalhesContainer",
        component: SolServDesovaDetalhesContainer,
        title: "Sol Serv Desova - Container"
    },
    {
        path: "/SolServDesova/IniciarDesova",
        component: SolServDesovaIniciarDesova,
        title: "Sol Serv Desova - Iniciar Desova"
    },
    {
        path: "/SolServDesova/InterromperDesova",
        component: SolServDesovaInterromperDesova,
        title: "Sol Serv Desova - Interromper"
    },
    {
        path: "/SolServDesova/DesovarVolume",
        component: SolServDesovaDesovarVolume,
        title: "Sol Serv Desova - Desovar Volume"
    },
    {
        path: "/SolServDesova/AvariasVolume",
        component: SolServDesovaAvariasVolume,
        title: "Sol Serv Desova - Avarias Volume"
    },
    {
        path: "/SolServDesova/ReconhecimentoVolume",
        component: SolServDesovaReconhecimentoVolume,
        title: "Sol Serv Desova - Reconhecimento Volume"
    },
    {
        path: "/SolServDesova/ReconhecerVolume",
        component: SolServDesovaReconhecerVolume,
        title: "Sol Serv Desova - Reconhecer Volume"
    },
    {
        path: "/SolServDesova/FinalizarDesova",
        component: SolServDesovaFinalizarDesova,
        title: "Sol Serv Desova - Finalizar Desova"
    },
    {
        path: "/SolServDesova/AvariasContainer",
        component: AvariasContainer,
        title: "Sol Serv Desova - Avarias Container"
    },
    {
        path: "/RemocaoVolume",
        component: RemocaoVolume,
        title: "Remoção Volume"
    },
    {
        path: "/EdicaoVolumes",
        component: EdicaoVolumes,
        title: "Edição Volumes"
    },
    {
        sidebarName: "Código de Barras",
        path: "/OperacaoContainer",
        component: OperacaoContainerCodigoDeBarras,
        title: "Operação Container - Código De Barras"
    },
    {
        sidebarName: "Operação Container",
        path: "/OperacaoContainer/Principal",
        component: OperacaoContainerPrincipal,
        title: "Operação Container - Operação"
    },
    {
        sidebarName: "Fiscal",
        path: "/OperacaoContainer/Fiscal",
        component: OperacaoContainerFiscal,
        title: "Operação Container - Fiscal",
    },
    {
        path: "/RemontagemVolume",
        component: RemontagemVolume,
        title: "Remontagem Volume",
    },
    {
        path: "/RemontagemVolume/RemontarVolume",
        component: RemontarVolume,
        title: "Remontagem Volume - Remontar"
    },
    {
        path: "/AvariaMovimentacaoVolume",
        component: AvariaMovimentacaoVolume,
        title: "Avaria Movimentação Volume",
    },
    {
        path: "/Confere",
        component: Confere,
        title: "Confere",
    },
    {
        path: "/ImagensEmGeral",
        component: ImagensEmGeral,
        title: "Imagens em Geral",
    },
    {
        path: "/Consulta",
        component: Consulta,
        title: "Consulta"
    },
    {
        path: "/ConfirmaImagem",
        component: ConfirmaImagem,
        title: 'Confirmar Imagem'
    },
    {
        path: "/TipoImagem",
        component: TipoImagem,
        title: 'Tipo Imagem'
    },
    {
        path: "/ImagensApp",
        component: ImagensApp,
        title: 'ImagensApp'
    },
    {
        path: "/VistoriaOEA",
        component: VistoriaOEA,
        title: 'Vistoria OEA - 7 Pontos'
    },
    {
        path: "/PortariaApp",
        component: PortariaApp,
        title: 'Portaria - App'
    }

];

export default RoutesMenu;
